import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';

export function loadMetadataSuccess(metadataType, metadata) {
  return { type: types.LOAD_METADATA_SUCCESS, metadataType, metadata };
}

export function loadMetadata(metadataType) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/${metadataType}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((metadata) => {
        dispatch(loadMetadataSuccess(metadataType, metadata.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/metadataActions.js